import { ListCodeCategories } from './ListCodeCategories/ListCodeCategories';
import { ListCodes } from './ListCodes/ListCodes';

/**
 * queries
 *
 * @type {{ListCodeCategories: ((function({}=): Promise<*>)|*), ListCodes: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  ListCodeCategories,
  ListCodes,
};
